/* global sessionStorage */
import rollbar from './Rollbar'
import { store } from '../configureStore'

export function loadState () {
  try {
    let serializedState = sessionStorage.getItem('overmedia')
    if (serializedState === null) {
      return undefined
    }
    return JSON.parse(serializedState)
  } catch (err) {
    console.log('Error when loading state from session storage', err)
    rollbar.error('Error when loading state from session storage', err)
    return undefined
  }
}

export function saveState (state) {
  try {
    console.log("SAVING STATE:", state)
    let serializedState = JSON.stringify(state)
    sessionStorage.setItem('overmedia', serializedState)
  } catch (err) {
    console.log('Error when saving state to session storage.', err)
    rollbar.error('Error when saving state to session storage.', err)
  }
}

export function clearState () {
  try {
    sessionStorage.clear()
  } catch (err) {
    console.log('Error when clearing session storage.', err)
    rollbar.error('Error when clearing session storage.', err)
  }
}

export function getAuthToken () {
  const state = store.getState();
  const token = state.app.user.authentication_token

  return token;

  // try {
  //   let serializedState = sessionStorage.getItem('overmedia')
  //   let token = JSON.parse(serializedState).app.user.authentication_token
  //   return token
  // } catch (err) {
  //   console.log('Error getting auth token.', err)
  //   rollbar.error('Error getting auth token.', err)
  // }
}

export function getCurrentUser () {
  const state = store.getState();
  const currentUser = {
    id: state.app.user.id,
    email: state.app.user.email,
    name: state.app.user.name
  }

  return currentUser;

  // try {
  //   let serializedState = sessionStorage.getItem('overmedia')
  //   if (serializedState === null) {
  //     return undefined
  //   }
  //   let parsedState = JSON.parse(serializedState)
  //   let currentUser = {
  //     id: parsedState.app.user.id,
  //     email: parsedState.app.user.email,
  //     name: parsedState.app.user.name
  //   }
  //   return currentUser
  // } catch (err) {
  //   console.log('Error when loading state from session storage', err)
  //   rollbar.error('Error when loading state from session storage', err)
  //   return undefined
  // }
}



// WEBPACK FOOTER //
// ./src/utils/sessionStorage.js